var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content mt-5"},[_c('div',{staticClass:"content-head"}),_c('div',{staticClass:"content-body p-3 p-sm-5 d-flex align-items-center justify-content-center"},[_c('h1',[_vm._v("Page not found")])])])])])
}]

export { render, staticRenderFns }